import { lnrFormApi, LNRFormCacheKey } from 'onboarding/api/lnrFormApi'

class LNRFormService {
  public getCrud(cacheKey?: LNRFormCacheKey) {
    return lnrFormApi.getCrud(cacheKey)
  }

  public fetchByRequestId(requestId: number, cacheKey?: LNRFormCacheKey) {
    return lnrFormApi.fetchByRequestId(requestId, cacheKey)
  }
}

export const lnrFormService = new LNRFormService()
